import { PropsWithChildren, ReactElement, ReactNode } from 'react'

import { TranscriptParagraphContent } from 'src/models/Transcript'
import { FONT_SIZE_BASE } from 'src/models/UIConfiguration'

const SINGLE_CHARACTER_WIDTH = 7.5

type CountLinesDto = {
    content: TranscriptParagraphContent[]
    maxWidth: number
    fontSize: number
}
export const countLines = ({ content, maxWidth, fontSize }: CountLinesDto) => {
    const fullText = content.map(({ text }) => text).join('')

    const characterWidth = (SINGLE_CHARACTER_WIDTH * fontSize) / FONT_SIZE_BASE

    return Math.ceil((fullText.length * characterWidth) / maxWidth)
}

export const getTextFromReactNode = (node: ReactNode): string => {
    if (typeof node === 'string') {
        return node
    }
    if (typeof node === 'number') {
        return node.toString()
    }
    if (Array.isArray(node)) {
        return node.map(getTextFromReactNode).join('')
    }
    if (typeof node === 'object' && !!node && (node as ReactElement).props) {
        return getTextFromReactNode((node as ReactElement<PropsWithChildren>).props.children)
    }

    return ''
}

export const isUUID = (text: string) => /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(text)

// NOTE: hyphenated words are counted as two separate words
// (i.e. "well-being" as 2 words and "up-to-date" as 3 words)
export const countWords = (input: string): number => {
    return input
        .trim()
        .split(/[\s-]+/)
        .filter(Boolean).length
}
